import React, { useState } from 'react'
import { Box } from '@mui/material'
import { makeStyles } from '@mui/styles'
import ExploreMenu from '../../../components/explore-menu'
import usePaidConsumerActions from '../hooks/usePaidConsumerActions'

const useStyles = makeStyles(({ spacing, palette, typography }) => ({
  navMenu: {
    display: 'flex',
    alignItems: 'center',
    gap: spacing(1)
  },
  // MT.3 — paid-consumer nav buttons render as ActionButton variant='link'.
  // `&&` doubles specificity so this class beats the variant's
  // primary-tinted `color` and `text-decoration: underline` on hover.
  navButton: {
    textTransform: 'none',
    borderRadius: spacing(1),
    padding: `${spacing(1)} ${spacing(2)}`,
    fontWeight: typography.fontWeightMedium,
    minHeight: 40,
    '&&': {
      color: palette.text.primary
    },
    '&&:hover': {
      backgroundColor: palette.primary.light,
      textDecoration: 'none'
    }
  }
}))

export const PaidConsumerNavMenu = () => {
  const classes = useStyles()
  const [showExplore, setShowExplore] = useState(false)

  const handleExploreToggle = () => {
    setShowExplore(show => !show)
  }

  const handleExploreMenuClose = () => {
    setShowExplore(false)
  }

  const { getActionComponents } = usePaidConsumerActions({
    onExploreToggle: handleExploreToggle,
    className: classes.navButton
  })

  const navItems = getActionComponents('desktop')

  return (
    <>
      <Box className={classes.navMenu}>
        {navItems}
      </Box>

      {/* Explore Menu - same behavior as Consumer Navigation */}
      <ExploreMenu open={showExplore} onClose={handleExploreMenuClose} />
    </>
  )
}
